import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-label-prompt-button',
  templateUrl: './label-prompt-button.component.html',
  styleUrls: ['./label-prompt-button.component.scss'],
})
/**
 * Label prompt button molecule
 */
export class LabelPromptButtonComponent {
  @Input() formGroup!: UntypedFormGroup;
  @Input() inputLabel!: string;
  @Input() inputDisabled = false;
  @Input() title!: string;
  @Input() abstractControlName!: string;
  @Input() buttonLabel!: string;
  @Input() buttonDisabled!: boolean;
  @Input() errorMsg = '';
  @Input() disabledBusiness!: boolean;
  @Output() submitAction = new EventEmitter<any>();

  /**
   * Wires up click action with input atom
   */
  onSubmit() {
    this.submitAction.emit();
  }

  /**
   * Returns abstract control associated with this prompt
   */
  get formControl() {
    return this.formGroup.get(this.abstractControlName) as FormControl;
  }
}
